<form
  class="cw"
  [style.--cw-bg]="colorFondo"
  [style.--cw-surface-text]="colorTexto"
  [style.--cw-surface-text-muted]="colorTexto"
  [style.--cw-accent]="colorBoton"
  [style.--cw-button-bg]="colorBoton"
  [style.--cw-button-text]="colorTextoBoton"
  [style.--cw-mas-info-color]="colorMasInfo"
  (ngSubmit)="enviarFormulario()"
>
  <div class="cw-head">
    @if (mostrarBotonCerrar) {
      <button type="button" class="cw-close" aria-label="Cerrar" (click)="cerrarWidget()">✕</button>
    }
    <span class="cw-eyebrow">Políticas de privacidad</span>
    <h1>{{ schema.title }}</h1>
    <p class="cw-subtitle">{{ schema.subtitle }}</p>
    <p class="cw-required-note">{{ schema.requiredFieldsNote }}</p>
  </div>

  <div class="cw-body">
    @for (fila of filasCampos; track $index) {
      <div class="cw-grid2">
        @for (campo of fila; track campo.id) {
          <div class="cw-field" [class.cw-field-full]="fila.length === 1">
            <label [for]="campo.id">{{ campo.label }}{{ campo.required ? ' *' : '' }}</label>
            <input
              [id]="campo.id"
              type="text"
              [placeholder]="campo.placeholder"
              [(ngModel)]="valores[campo.id]"
              [name]="campo.id"
              [required]="campo.required"
            />
          </div>
        }
      </div>
    }

    <div class="cw-select-all">
      <input
        type="checkbox"
        id="cw-main-consent"
        [checked]="todasLasFinalidadesMarcadas"
        (change)="toggleSeleccionarTodas($any($event.target).checked)"
      />
      <label for="cw-main-consent">{{ schema.mainConsentLabel }}</label>
    </div>

    <button
      type="button"
      class="cw-more-info"
      [attr.aria-expanded]="legalDetailOpen"
      (click)="toggleLegalDetail()"
    >
      Quiero ver más información
      <span class="cw-car">{{ legalDetailOpen ? '▲' : '▼' }}</span>
    </button>

    @if (legalDetailOpen) {
      <div class="cw-legal-detail">
        <p class="cw-legal-intro">{{ legalIntroResuelto }}</p>

        <div class="cw-acc">
          <button
            type="button"
            class="cw-acc-h"
            [attr.aria-expanded]="accOpen.necesarias"
            (click)="toggleAcordeon('necesarias')"
          >
            {{ schema.finalidadesNecesariasLabel }}
            <span class="cw-car">{{ accOpen.necesarias ? '▲' : '▼' }}</span>
          </button>
          @if (accOpen.necesarias) {
            <div class="cw-acc-body">
              @for (parrafo of schema.finalidadesNecesarias; track $index) {
                <p>{{ parrafo }}</p>
              }
            </div>
          }
        </div>

        <div class="cw-acc">
          <button
            type="button"
            class="cw-acc-h"
            [attr.aria-expanded]="accOpen.adicionales"
            (click)="toggleAcordeon('adicionales')"
          >
            {{ schema.finalidadesAdicionalesLabel }}
            <span class="cw-car">{{ accOpen.adicionales ? '▲' : '▼' }}</span>
          </button>
          @if (accOpen.adicionales) {
            <div class="cw-acc-body">
              <p class="cw-fin-helper">{{ schema.finalidadesAdicionalesHelperText }}</p>

              @for (fin of schema.finalidadesAdicionales; track fin.code) {
                <div class="cw-fin-item">
                  <input
                    type="checkbox"
                    [id]="'cw-fin-' + fin.code"
                    [(ngModel)]="finalidadesMarcadas[fin.code]"
                    [name]="'fin-' + fin.code"
                  />
                  <label class="cw-fin-text" [for]="'cw-fin-' + fin.code">
                    <b>{{ fin.label }}</b>
                    @for (chunk of descripcionChunks(fin); track $index) {
                      @if (chunk.url !== null) {
                        <a [href]="chunk.url" target="_blank" rel="noopener">{{ chunk.text }}</a>
                      } @else {
                        {{ chunk.text }}
                      }
                    }
                  </label>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

    <div class="cw-acceptance">
      <input
        type="checkbox"
        id="cw-acceptance-cb"
        [(ngModel)]="aceptaPoliticas"
        name="aceptaPoliticas"
        required
      />
      <label for="cw-acceptance-cb">
        @for (chunk of acceptanceChunks; track $index) {
          @if (chunk.linkId) {
            <a [href]="chunk.linkUrl ?? '#'" target="_blank" rel="noopener">{{ chunk.linkLabel }}</a>
          } @else {
            {{ chunk.text }}
          }
        }
      </label>
    </div>

    @if (mostrarExito) {
      <div class="cw-exito">✓ Tu autorización fue enviada correctamente.</div>
    }

    <div class="cw-actions">
      <button type="submit" class="cw-submit" [disabled]="enviando || !formularioValido">Autorizar y Enviar</button>
    </div>

    <p class="cw-footer-note">{{ schema.footerLegalNote }}</p>
  </div>
</form>
